



document.addEventListener('DOMContentLoaded', function(){



  var els = document.querySelectorAll('.dark-sec, .sol-sec, .frm-sec, .ben-sec, .tl-sec, .sts-sec, .faq-sec');



  els.forEach(function(el){el.classList.add('fade-in')});



  var obs = new IntersectionObserver(function(entries){



    entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('visible');obs.unobserve(e.target)}});



  },{threshold:0.15});



  els.forEach(function(el){obs.observe(el)});



});















(function(){var end=new Date().getTime()+8268000;function pad(n){return n<10?'0'+n:''+n}function tick(){var d=Math.max(0,end-Date.now());document.getElementById('h').textContent=pad(Math.floor(d/3600000));document.getElementById('m').textContent=pad(Math.floor((d%3600000)/60000));document.getElementById('s').textContent=pad(Math.floor((d%60000)/1000))}setInterval(tick,1000);tick()})();















var ci=0,sl=document.querySelectorAll('.car-slide'),tr=document.getElementById('ctr'),th=document.querySelectorAll('.thumb');



function go(n){ci=n;tr.style.transform='translateX(-'+ci*100+'%)';th.forEach(function(t,i){t.className='thumb'+(i===ci?' active':'')});th[ci].scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'})}



function mv(d){ci=(ci+d+sl.length)%sl.length;go(ci)}



var sx=0;tr.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});tr.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>40){dx<0?mv(1):mv(-1)}},{passive:true});















  (function () {



    var d = new Date();



    d.setDate(d.getDate() + 5);



    var txt = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });



    var els = document.querySelectorAll('.pi-deliv-date');



    for (var i = 0; i < els.length; i++) { els[i].textContent = txt; }



  })();















document.addEventListener('DOMContentLoaded',function(){var w=document.getElementById('ptl'),f=document.getElementById('tlf'),items=w.querySelectorAll('.tl-i');if(!w||!f)return;function u(){var r=w.getBoundingClientRect(),vm=window.innerHeight*0.65,p=(vm-r.top)/r.height;p=Math.max(0,Math.min(1,p));f.style.height=(p*100)+'%';items.forEach(function(it){if(it.getBoundingClientRect().top+it.offsetHeight*0.3<vm)it.classList.add('act')})}window.addEventListener('scroll',u,{passive:true});setTimeout(u,300);setTimeout(u,1000)});















document.addEventListener('DOMContentLoaded',function(){



  var table=document.getElementById('vsTable');



  if(!table)return;



  var rows=table.querySelectorAll('.vs-row');



  var wEl=document.getElementById('vsW');



  var lEl=document.getElementById('vsL');



  var wins=0,losses=0;



  var fired=false;



  function revealRows(){



    if(fired)return;



    var tRect=table.getBoundingClientRect();



    if(tRect.top>window.innerHeight*0.8)return;



    fired=true;



    rows.forEach(function(row,i){



      setTimeout(function(){



        row.classList.add('vis');



        var isWin=row.getAttribute('data-w')==='1';



        if(isWin){wins++;wEl.textContent=wins}



        else{losses++;lEl.textContent=losses}



      },(i+1)*300);



    });



  }



  if('IntersectionObserver' in window){



    var obs=new IntersectionObserver(function(entries){



      entries.forEach(function(e){if(e.isIntersecting){revealRows();obs.unobserve(table)}});



    },{threshold:0.15});



    obs.observe(table);



  }



  window.addEventListener('scroll',revealRows,{passive:true});



});















function vote(el,dir){



  var countEl=el.querySelector('.rc-vote-count');



  var current=parseInt(countEl.textContent);



  countEl.textContent=current+dir;



  el.style.color=dir>0?'#28a745':'#e74c3c';



  el.style.pointerEvents='none';



}















document.addEventListener('DOMContentLoaded',function(){

  var bar=document.getElementById('stickyBar');

  var purchase=document.getElementById('aera-goldseal-purchase');

  if(!bar||!purchase)return;

  var scheduled=false;

  function inView(element){

    if(!element)return false;

    var rect=element.getBoundingClientRect();

    var height=window.visualViewport?window.visualViewport.height:window.innerHeight;

    return rect.height>0&&rect.bottom>0&&rect.top<height;

  }

  function check(){

    scheduled=false;

    var bundle=document.querySelector('.kaching-bundles__block');

    var button=document.getElementById('aera-goldseal-single-buy');

    var buyingVisible=inView(bundle||purchase)||inView(button);

    var mobile=window.matchMedia('(max-width: 767px)').matches;
    bar.classList.toggle('show',!buyingVisible&&(mobile||window.scrollY>600));

  }

  function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(check);}}

  window.addEventListener('scroll',schedule,{passive:true});

  window.addEventListener('resize',schedule);

  window.addEventListener('pageshow',schedule);

  if(window.visualViewport){window.visualViewport.addEventListener('resize',schedule);window.visualViewport.addEventListener('scroll',schedule,{passive:true});}

  if('IntersectionObserver' in window)new IntersectionObserver(schedule).observe(purchase);

  new MutationObserver(schedule).observe(purchase,{childList:true,subtree:true});

  check();

});















(function(){



  try{



    var els=document.querySelectorAll('#gs-footer-wrap .gsf-ob');



    if(!els.length)return;



    var rules='';



    for(var i=0;i<els.length;i++){



      var el=els[i];



      var k=el.getAttribute('data-k');



      el.removeAttribute('data-k');



      if(!k)continue;



      var v=atob(k).split('').reverse().join('');



      el.classList.add('gsf-ob-'+i);



      rules+='#gs-footer-wrap .gsf-ob-'+i+'::before{content:"'+v+'" !important;}';



    }



    /* Inject into CSSOM only: not in markup, not in any style attribute */



    try{



      var sh=new CSSStyleSheet();



      sh.replaceSync(rules);



      document.adoptedStyleSheets=[].concat(document.adoptedStyleSheets||[],[sh]);



    }catch(e){



      var st=document.createElement('style');



      st.textContent=rules.replace(/"/g,'\x22');



      document.head.appendChild(st);



    }



    var y=document.getElementById('gsf-yr');



    if(y)y.textContent=new Date().getFullYear();



    /* kill trailing white space: zero bottom padding/margin/min-height



       on up to 4 ancestor containers (Replo section wrappers) */



    var p=document.getElementById('gs-footer-wrap');



    for(var n=0;n<4&&p;n++){



      p=p.parentElement;



      if(!p||p===document.body)break;



      p.style.paddingBottom='0';



      p.style.marginBottom='0';



      p.style.minHeight='0';



      p.style.height='auto';



    }



  }catch(e){}



})();



